import { User } from "../user/user.model";

export enum OfferStatus {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Refused = 'Refused',
    Expired = 'Expired',
    Revoked = 'Revoked'
}

export interface LeadOffer {
    offeror: User,
    offeree: User,

    status: OfferStatus,

    expiration: Date,
    created: Date,
    updated: Date
}